"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPF_SPAN_TYPES = void 0;
exports.IPF_SPAN_TYPES = ['fore_span', 'back_span', 'other'];
//# sourceMappingURL=Span.js.map